import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Grid, TextField } from "@material-ui/core";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
import { getAllServices } from "../../../services/Services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "الطلبات المدفوعة",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const AllLiretnaTransferTo = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [personName, setPersonName] = React.useState([]);
  const [orderType, setOrderType] = useState("");
  const [ToMobileTransction, setToMobileTransction] = useState(false);
  const [ServicesData, setServices] = useState([]);

  const mobile_number_login = localStorage.getItem("mobile_number_login");
  const type_order = [
    { id: "prepaid", title: "مدفوع" },
    { id: "postpaid", title: "غير مدفوع" },
  ];
  const names = [
    "ليرتنا كاش",
    "وحدات Syriatel",
    "فاتورة Syriatel",
    "كاش Syriatel",
    "وحدات MTN",
    "فاتورة MTN",
    "MTN كاش",
  ];
  useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
        withCredentials: true,
      })
      .then((res) => {
        setUsers(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });
    getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });
    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };
  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleChange = (event) => {
    if (event.target.value.length === 0) {
      axios
        .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
          withCredentials: true,
        })
        .then((res) => {
          setUsers(res.data.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
    if (event.target.name === "fund_name") {
      setPersonName(event.target.value);
      if (orderType == "") {
        const selectedOptions = event.target.value;
        axios
          .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
            withCredentials: true,
          })
          .then((res) => {
            const data = res.data.data;

            const filteredData = data.filter((row) => {
              const filterByOrderType =
                orderType.length > 0 ? orderType.includes(row.code_name) : true;
              const filterByPersonName =
                selectedOptions.length > 0
                  ? selectedOptions.includes(row.fund_name)
                  : true;
              const filterByToMobileTransction =
                mobile_number_login.length > 0
                  ? mobile_number_login.includes(row.to_mobile_number)
                  : true;
              const filterByMobileNumberLogin =
                ToMobileTransction.length > 0
                  ? ToMobileTransction.includes(row.from_mobile_number)
                  : true;

              return (
                filterByOrderType &&
                filterByPersonName &&
                filterByToMobileTransction &&
                filterByMobileNumberLogin
              );
            });
            setUsers(filteredData);

            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      } else {
        const selectedOptions = event.target.value;
        const order_type = orderType;
        axios
          .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
            withCredentials: true,
          })
          .then((res) => {
            const data = res.data.data;

            const filteredData = data.filter((row) => {
              const filterByOrderType =
                orderType.length > 0 ? orderType.includes(row.code_name) : true;
              const filterByPersonName =
                selectedOptions.length > 0
                  ? selectedOptions.includes(row.fund_name)
                  : true;
              const filterByToMobileTransction =
                ToMobileTransction.length > 0
                  ? ToMobileTransction.includes(row.to_mobile_number)
                  : true;
              const filterByMobileNumberLogin =
                mobile_number_login.length > 0
                  ? mobile_number_login.includes(row.from_mobile_number)
                  : true;

              return (
                filterByOrderType &&
                filterByPersonName &&
                filterByToMobileTransction &&
                filterByMobileNumberLogin
              );
            });
            setUsers(filteredData);

            setUsers(filteredData);
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }
    if (event.target.name === "order_type") {
      setOrderType(event.target.value);
      if (personName == "") {
        const selectedOptions = event.target.value;
        axios
          .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
            withCredentials: true,
          })
          .then((res) => {
            const data = res.data.data;

            const filteredData = data.filter((row) => {
              const filterByOrderType =
                selectedOptions.length > 0
                  ? selectedOptions.includes(row.code_name)
                  : true;
              const filterByPersonName =
                personName.length > 0
                  ? personName.includes(row.fund_name)
                  : true;
              const filterByToMobileTransction =
                ToMobileTransction.length > 0
                  ? ToMobileTransction.includes(row.from_mobile_number)
                  : true;
              const filterByMobileNumberLogin =
                mobile_number_login.length > 0
                  ? mobile_number_login.includes(row.to_mobile_number)
                  : true;

              return (
                filterByOrderType &&
                filterByPersonName &&
                filterByToMobileTransction &&
                filterByMobileNumberLogin
              );
            });

            setUsers(filteredData);
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      } else {
        const selectedOptions = event.target.value;
        const order_type = personName;
        axios
          .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
            withCredentials: true,
          })
          .then((res) => {
            const data = res.data.data;

            const filteredData = data.filter((row) => {
              const filterByOrderType =
                selectedOptions.length > 0
                  ? selectedOptions.includes(row.code_name)
                  : true;
              const filterByPersonName =
                personName.length > 0
                  ? personName.includes(row.fund_name)
                  : true;
              const filterByToMobileTransction =
                ToMobileTransction.length > 0
                  ? ToMobileTransction.includes(row.from_mobile_number)
                  : true;
              const filterByMobileNumberLogin =
                mobile_number_login.length > 0
                  ? mobile_number_login.includes(row.to_mobile_number)
                  : true;

              return (
                filterByOrderType &&
                filterByPersonName &&
                filterByToMobileTransction &&
                filterByMobileNumberLogin
              );
            });

            setUsers(filteredData);
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }

    if (event.target.name === "from_mobile_number") {
      setToMobileTransction(event.target.value);

      if (event.target.value.length == 0) {
        const selectedOptions = event.target.value;
        axios
          .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
            withCredentials: true,
          })
          .then((res) => {
            const data = res.data.data;
            const filteredData = data.filter((row) => {
              const filterByOrderType =
                orderType.length > 0 ? orderType.includes(row.code_name) : true;
              const filterByPersonName =
                personName.length > 0
                  ? personName.includes(row.fund_name)
                  : true;
              const filterBySelectedOptions =
                selectedOptions.length > 0
                  ? selectedOptions.includes(row.from_mobile_number)
                  : true;
              const filterByMobileNumberLogin =
                mobile_number_login.length > 0
                  ? mobile_number_login.includes(row.to_mobile_number)
                  : true;
              return (
                filterByOrderType &&
                filterByPersonName &&
                filterBySelectedOptions &&
                filterByMobileNumberLogin
              );
            });
            setUsers(filteredData);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setIsLoading(false);
          });
      } else if (event.target.value.length === 10) {
        const selectedOptions = event.target.value;
        axios
          .get(`${BaseUrl}/api/getAllTransactiontoMe`, {
            withCredentials: true,
          })
          .then((res) => {
            const data = res.data.data;
            const filteredData = data.filter((row) => {
              const filterByOrderType =
                orderType.length > 0 ? orderType.includes(row.code_name) : true;
              const filterByPersonName =
                personName.length > 0
                  ? personName.includes(row.fund_name)
                  : true;
              const filterBySelectedOptions =
                selectedOptions.length > 0
                  ? selectedOptions.includes(row.from_mobile_number)
                  : true;
              const filterByMobileNumberLogin =
                mobile_number_login.length > 0
                  ? mobile_number_login.includes(row.to_mobile_number)
                  : true;

              return (
                filterByOrderType &&
                filterByPersonName &&
                filterBySelectedOptions &&
                filterByMobileNumberLogin
              );
            });

            setUsers(filteredData);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setIsLoading(false);
          });
      }
    }
  };
  const columns = [
    {
      field: "staff_from",
      headerName: "المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to",
      headerName: "المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to_type",
      headerName: "نوع العميل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "from_mobile_number",
      headerName: "رقم المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "to_mobile_number",
      headerName: "رقم المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "payment_method_ar",
      headerName: "طريقة الدفع",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "fund_name",
      headerName: "اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "fund_company",
      headerName: "رصيد الشركة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_berfore",
      headerName: "الرصيد قبل ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after",
      headerName: "الرصيد بعد ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount",
      headerName: "كمية الرصيد ",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "created_at",
      headerName: "تاريخ التحويلة",
      headerAlign: "center",
      align: "center",
      minWidth: 200,
      maxWidth: 200,
      editable: false,
    },
  ];
  const staff_type = localStorage.getItem("staff_type");
  return (
    <Box m="2px 5px 0px 5px">
      <Header />
      {ServicesData[6]?.name == "Transactions" &&
      ServicesData[6]?.is_active == 1 ? (
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <Grid style={{ display: "flex" }}>
            <FormControl style={{ width: "300px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label"
                style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
              >
                فلترة حسب اسم الرصيد
              </InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<Input />}
                renderValue={(selected) => selected.join(", ")}
                name="fund_name"
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={{ width: "300px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label1"
                style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
              >
                فلترة حسب نوع التحويل
              </InputLabel>
              <Select
                value={orderType}
                onChange={handleChange}
                input={<Input />}
                name="order_type"
              >
                {type_order.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                name="from_mobile_number"
                onChange={handleChange}
                label="رقم المرسل"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                name="to_mobile_number"
                label="رقم المستقبل"
                disabled
                value={mobile_number_login}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
          </Grid>
          <DataGridPro
            rows={users}
            className="field-table"
            columns={columns}
            editMode="row"
            pageSize={10}
            pagination
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
              toolbarColumns: "الأعمدة",
              toolbarFilters: "الفلاتر",
              toolbarDensity: "التباعد",
              toolbarExport: "تصدير",
              filterPanelAddFilter: "إضافة فلتر",
              filterOperatorContains: "تحتوي",
              filterOperatorEquals: "تساوي",
              filterOperatorStartsWith: "تبدأ ب",
              filterOperatorEndsWith: "تنتهي  ب",
              filterOperatorIsAnyOf: "هو أي من",
              filterOperatorIsEmpty: "فارغ",
              filterOperatorIsNotEmpty: "غير فارغ",
              toolbarDensityCompact: "دمج",
              toolbarDensityStandard: "معيار",
              toolbarDensityComfortable: "مريح",
              toolbarExportCSV: "تصدير CSV",
              toolbarExportPrint: "طباعة",
              filterPanelInputLabel: "القيمة",
              filterPanelInputPlaceholder: "ادخل القيمة",
              filterPanelColumns: "الاعمدة",
              filterPanelOperators: "العمليات",
              columnsPanelTextFieldLabel: "بحث عن عمود",
              columnsPanelTextFieldPlaceholder: "عنوان العمود",
            }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) :  ServicesData[6]?.name == "Transactions" &&
        ServicesData[6]?.is_active == 0 && staff_type == "Admin" &&
                  mobile_number_login == "0950555563"? (
                    <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <Grid style={{ display: "flex" }}>
            <FormControl style={{ width: "300px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label"
                style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
              >
                فلترة حسب اسم الرصيد
              </InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<Input />}
                renderValue={(selected) => selected.join(", ")}
                name="fund_name"
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={{ width: "300px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label1"
                style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
              >
                فلترة حسب نوع التحويل
              </InputLabel>
              <Select
                value={orderType}
                onChange={handleChange}
                input={<Input />}
                name="order_type"
              >
                {type_order.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                name="from_mobile_number"
                onChange={handleChange}
                label="رقم المرسل"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                name="to_mobile_number"
                label="رقم المستقبل"
                disabled
                value={mobile_number_login}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
          </Grid>
          <DataGridPro
            rows={users}
            className="field-table"
            columns={columns}
            editMode="row"
            pageSize={10}
            pagination
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
              toolbarColumns: "الأعمدة",
              toolbarFilters: "الفلاتر",
              toolbarDensity: "التباعد",
              toolbarExport: "تصدير",
              filterPanelAddFilter: "إضافة فلتر",
              filterOperatorContains: "تحتوي",
              filterOperatorEquals: "تساوي",
              filterOperatorStartsWith: "تبدأ ب",
              filterOperatorEndsWith: "تنتهي  ب",
              filterOperatorIsAnyOf: "هو أي من",
              filterOperatorIsEmpty: "فارغ",
              filterOperatorIsNotEmpty: "غير فارغ",
              toolbarDensityCompact: "دمج",
              toolbarDensityStandard: "معيار",
              toolbarDensityComfortable: "مريح",
              toolbarExportCSV: "تصدير CSV",
              toolbarExportPrint: "طباعة",
              filterPanelInputLabel: "القيمة",
              filterPanelInputPlaceholder: "ادخل القيمة",
              filterPanelColumns: "الاعمدة",
              filterPanelOperators: "العمليات",
              columnsPanelTextFieldLabel: "بحث عن عمود",
              columnsPanelTextFieldPlaceholder: "عنوان العمود",
            }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) : 
       ServicesData[6]?.name == "Transactions" &&
        ServicesData[6]?.is_active == 0 ? (
        <div class="services-no-available">
          هذه الخدمة غير متاحة
          <img src="7703205.webp" />
        </div>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default AllLiretnaTransferTo;
